<template>
  <el-container class="page-login">
    <!-- logo -->
    <el-header class="login-header" height="200px">
      <span class="logo">
        <img src="./assets/img/lhlogo.png" alt />
      </span>
      <h1 class="title">欢迎使用罗湖区智慧教育云平台</h1>
      <!-- <h1 class="title">欢迎使用罗湖教育移动办公平台</h1> -->
    </el-header>

    <!-- 账号登录 -->
    <el-main class="login-main">
      <div class="login-index" v-if="false">
        <div class="login-type">
          <p class="login-title">登录</p>
        </div>
        <el-form :model="formData" status-icon ref="form">
          <el-form-item prop="OrganizationCode" :error="errorMessage">
            <div class="account">
              <el-input
                placeholder="请输入组织机构码"
                v-model="formData.OrganizationCode"
                prefix-icon="el-icon-mobile-phone"
                @change="handleOrganizationCodeChange"
              ></el-input>
            </div>
          </el-form-item>
          <h3 style="text-align: center;">{{ company_name }}</h3>
          <template v-if="!isSync && !isLogged">
            <el-form-item prop="acct" v-if="had_exec == 0 && company_name">
              <div class="account">
                <el-input
                  placeholder="手机号/邮箱"
                  v-model="formData.acct"
                  prefix-icon="el-icon-mobile-phone"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item class="" prop="password" v-if="had_exec == 0 && company_name">
              <div class="password">
                <el-input
                  type="password"
                  placeholder="密码"
                  v-model="formData.password"
                  prefix-icon="el-icon-key"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item v-if="captchaCodeUrl.length > 0" class="" prop="code">
              <div class="password">
                <el-input
                  placeholder="验证码"
                  v-model="formData.code"
                  class="captchaCode"
                ></el-input>
                <img
                  class="captchaCodeImg"
                  @click="changeCaptchaCodeUrl"
                  :src="captchaCodeUrl"
                  alt=""
                />
                <!-- <el-image
                  @click="changeCaptchaCodeUrl"
                  :src="captchaCodeUrl"
                ></el-image> -->
              </div>
            </el-form-item>
            <el-form-item v-if="had_exec == 0 && company_name">
              <div class="controler">
                <el-button type="primary" class="login-btn" @click="login"
                  >登录</el-button
                >
                <!-- <p class="controler-info  green" @click="$router.push('/registry')">没有账号？立即注册</p> -->
              </div>
            </el-form-item>
          </template>
          <template v-if="isSync">
            <h3 style="text-align: center;line-height: 2;color: red;">请勿关闭页面,系统正在同步通讯录{{ syncProgress }}%</h3>
          </template>
          <template v-if="!isSync && isLogged">
            <el-form-item prop="userid">
              <div class="account">
                <el-input
                  placeholder="请输入企微账号绑定超级管理员"
                  v-model="formData.userid"
                  prefix-icon="el-icon-mobile-phone"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="controler">
                <el-button type="primary" class="login-btn" @click="onConfirmBinding">确认绑定</el-button>
              </div>
            </el-form-item>
          </template>
          <el-form-item v-show="loginEqCode">
            <div class="qrcodeDiv">
              <div @click="getQRCode" id="qrcode"></div>
            </div>
            <div class="scanedQrcode">
              <template v-if="scanedQrcode">
                <img src="./assets/img/ok.png" alt />
                <p class="p1">扫码成功</p>
                <p class="p2">请在企业微信中点击确认即可登录</p>
              </template>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 旧的内容 -->
      <div class="login-index">
        <div class="login-type">
          <p class="login-title">账号登录</p>
          <div class="imgs">
            <img src="./assets/img/codeLoginText.png" class="img1" />
            <img
              src="./assets/img/codeLogin.png"
              class="img2"
              @click="loginCode"
            />
          </div>
        </div>
        <el-form :model="formData" status-icon ref="form">
          <el-form-item prop="acct">
            <div class="account">
              <el-input
                placeholder="手机号/邮箱"
                v-model="formData.acct"
                prefix-icon="el-icon-mobile-phone"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item class="" prop="password">
            <div class="password">
              <el-input
                type="password"
                placeholder="密码"
                v-model="formData.password"
                prefix-icon="el-icon-key"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item v-if="captchaCodeUrl.length > 0" class="" prop="code">
            <div class="password">
              <el-input
                placeholder="验证码"
                v-model="formData.code"
                class="captchaCode"
              ></el-input>
              <img
                class="captchaCodeImg"
                @click="changeCaptchaCodeUrl"
                :src="captchaCodeUrl"
                alt=""
              />
              <!-- <el-image
                @click="changeCaptchaCodeUrl"
                :src="captchaCodeUrl"
              ></el-image> -->
            </div>
          </el-form-item>
          <!-- <el-form-item prop="password">
            <div>
              <el-input
                placeholder="验证码"
                v-model="formData.password"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  style="font-size: 13px;color: #909399;"
                  :disabled="count !== 0"
                  @click.prevent="sendCode()"
                  >{{
                    count === 0 ? "发送验证码" : `重新发送(${count}s)`
                  }}</el-button
                >
              </el-input>
            </div>
          </el-form-item> -->
          <el-form-item>
            <div class="controler">
              <div class="controler-check">
                <div class="check-left">
                  <el-checkbox
                    v-model="markAcct"
                    @change="markAcctFn"
                    text-color="#59c3aa"
                    fill="#59c3aa"
                    >记住一周</el-checkbox
                  >
                </div>
                <div class="check-right forgetPassword">
                  <span class="green" @click="forget">忘记密码?</span>
                </div>
              </div>
              <el-button type="primary" class="login-btn" @click="login"
                >登录</el-button
              >
              <!-- <p class="controler-info  green" @click="$router.push('/registry')">没有账号？立即注册</p> -->
            </div>
          </el-form-item>
        </el-form>
      </div>

    </el-main>
    <foot :cpString="cpString"></foot>
  </el-container>
</template>

<script>
import foot from "@/components/pcFrom/foot.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { menuData } from "./config/menuDataHT";
import QRCode from "qrcodejs2";
import { _getQuery } from '../../assets/js/util'
// import { filterByPrivilege } from "./config/menuDataYw";
// import io from "socket.io-client";
// console.log(filterByPrivilege);

export default {
  data() {
    return {
      formData: {
        acct: "",
        password: "",
        com_id: "",
        code: "",
        OrganizationCode: ""
      },
      markAcct: false,
      count: 0,
      cpString: menuData.cpString,
      loginType: 1,
      captchaCodeUrl: "",
      loginEqCode: "",
      loginInterval: null,
      qrcodeObj: null,
      errorMessage: '',
      company_name: '',
      had_exec: 0,
      isSync: 0,
      isLogged: 0,
      syncProgress: '',
      scanedQrcode: false
    };
  },
  components: {
    foot
  },

  async created() {
    let host = location.host;
    if (host == "tms.hrpack.com") {
      // 生产
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    } else if (host == "tmstest.hrpack.com") {
      // UAT
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    } else {
      // 测试
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    }
    // this.keyupSubmit();
  },

  mounted() {
    // 填充密码
    this.$nextTick(() => {
      let corp_url = _getQuery('corp_url');
      if (corp_url) {
        this.formData.OrganizationCode = corp_url;
        this.handleOrganizationCodeChange();
      }
      let query = this.$common.getCookie("my_acct");
      if (query) {
        let acctArr = query.split("&").map(item => {
          return item.split("=")[1];
        });
        this.formData.acct = acctArr[0];
        this.formData.password = acctArr[1];
        this.markAcct = true;
      }
    });
    // setTimeout(() => {
    //   this.setAdminInfo({ aaa: 123123, bbb: 444 });
    // }, 5000);
  },

  computed: {
    ...mapGetters([
      "privilegeConfig",
      "adminInfo",
      "socketObj",
      "socketMsgList",
      "firstPath"
    ])
  },

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.loginInterval);
    next();
  },

  methods: {
    ...mapActions(["fetchPrivilege"]),
    ...mapMutations([
      "setPrivilegeConfig",
      "setAdminInfo",
      "initSocket",
      "sendSocket"
    ]),
    // 忘记密码
    forget() {
      window.location.href = "/index.php?m=login&a=forgot_password";
    },
    changeCaptchaCodeUrl() {
      this.captchaCodeUrl = "/code.php?" + "t=" + new Date().getTime();
    },
    // 二维码登录
    loginCode() {
      // this.$router.push("/nhqy/login");
    },
    async login() {
      this.$common
        .http({
          url: "/index.php?m=login",
          data: {
            ajax_act: "login",
            data: JSON.stringify({
              acct: this.formData.acct,
              password: this.formData.password,
              code: this.formData.code,
              cache_acct: 0
            })
          }
        })
        .then(
          loginRs => {
            console.log(loginRs, "loginRs");
            if (loginRs.data.errcode == 0) {
              window.location.href = "/index.php";
              this.$common.pcSuccess("登录成功");
              // this.$common.http({
              //   url: '/index.php?model=member&m=ajax&cmd=121'
              // }).then(() => {
              //   this.getMenberSyncProgress();
              // })
            } else {
              this.captchaCodeUrl = "/code.php?" + "t=" + new Date().getTime();
            }
          },
          () => {
            this.captchaCodeUrl = "/code.php?" + "t=" + new Date().getTime();
          }
        );
    },
    getMenberSyncProgress() {
      let _this = this;
      let url = '/index.php?model=member&m=ajax&cmd=124'
      this.$common.http({ method: 'get', url }).then((resp) => {
        _this.syncProgress = Number(resp.data.info.percent).toFixed(2)
        _this.isSync = 1
        if (resp.data.info.percent < 100) {
          setTimeout(() => {
            _this.getMenberSyncProgress();
          }, 3000)
        } else {
          // alert('同步完成')
          _this.isSync = 0
          _this.isLogged = 1
        }
      })
    },
    // 进入系统
    async intoSysTem(token, res) {
      // window.localStorage.setItem("token", token);
      // token 值
      let projectNameArray = window.location.pathname.split("/");
      let projectName = (projectNameArray[1] || "") + "token";
      window.localStorage.setItem(projectName, token);
      // 同浏览器的不同tab同时刷新
      window.localStorage.setItem("changeFactory", new Date().getTime());
      // 保存当前用户信息
      this.setAdminInfo(res);
      // socket链接
      // this.initSocket();
      // 获取权限
      await this.fetchPrivilege();
      console.log(
        "当前用户权限Privilege",
        this.privilegeConfig,
        this.firstPath
      );
      this.$router.push("/rhqy/lyout");
    },
    // 记住密码
    markAcctFn() {
      if (this.markAcct) {
        const query = `acct=${this.formData.acct}&pass=${this.formData.password}`;
        this.$common.setCookie({
          key: "my_acct",
          value: query,
          expires: 7 * 24 * 60 * 60 * 1000
        });
      } else {
        this.$common.removeCookie("my_acct");
      }
    },
    // 回车登录
    // keyupSubmit() {
    //   // const pThis = this;
    //   // document.onkeydown = () => {
    //   //   if (pThis.$route.path === "/rhqy/login") {
    //   //     let _key = window.event.keyCode;
    //   //     if (_key === 13) {
    //   //       pThis.login();
    //   //     }
    //   //   }
    //   // };
    // },

    // 发送验证码
    sendCode() {
      if (
        !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(
          this.formData.acct
        )
      ) {
        this.$common.pcError("请输入正确的手机号");
        return;
      }
      this.$common
        .http({
          url: "/qyapi/authorize/send_sms_code",
          data: {
            phone: this.formData.acct
          }
        })
        .then(() => {
          this.count = 60;
          this.$common.success("发送成功");
        });
    },
    // getQRCode() {
    //   if (this.loginInterval) {
    //     window.clearInterval(this.loginInterval);
    //   }
    //   const moblieUrl = encodeURIComponent(
    //     `/rhwx/index.html#/rhwx/checkPcEqCodeLogin?t=${new Date().getTime()}`
    //   );
    //   this.$common
    //     .http({
    //       method: "get",
    //       url: `/api/authorize/get_wxwork_login_qrcode?com_id=${this.formData.com_id}&src_url=${moblieUrl}`
    //     })
    //     .then(res => {
    //       this.uid = res.data.data.uid;
    //       this.loginEqCode = res.data.data.url;
    //       if (this.qrcodeObj) {
    //         this.qrcodeObj.clear();
    //       }
    //       document.getElementById("qrcode").innerHTML = "";
    //       this.qrcodeObj = new QRCode("qrcode", {
    //         width: 300,
    //         height: 300,
    //         text: this.loginEqCode
    //       });
    //       this.startLoginInterval();
    //     });
    // },
    changeLoginType() {
      if (this.loginType == 1) {
        this.loginType = 2;
        this.getQRCode();
      } else {
        this.loginType = 1;
        window.clearInterval(this.loginInterval);
      }
    },
    // startLoginInterval() {
    //   this.loginInterval = window.setInterval(() => {
    //     this.$common
    //       .http({
    //         method: "get",
    //         url: `/api/authorize/wxwork_qrcode_login_check?uid=${this.uid}`,
    //         noLoading: true
    //       })
    //       .then(res => {
    //         if (res.data.data.token) {
    //           window.clearInterval(this.loginInterval);
    //           this.intoSysTem(res.data.data.token, {});
    //         } else {
    //           if (res.data.data.status == "CANCEL") {
    //             this.$common.pcToastFail("已取消登录");
    //             this.getQRCode();
    //           }
    //           if (res.data.data.status == "NO_PERMISSION") {
    //             this.$common.pcToastFail("无权限");
    //             this.getQRCode();
    //           }
    //         }
    //       });
    //   }, 1000);
    // },
    startLoginInterval() {
      this.loginInterval = window.setInterval(() => {
        // let data = {
        //   uid: this.uid,
        //   corp_url: this.corp_url
        // }
        this.$common
          .http({
            method: "get",
            url: `/index.php?model=login&a=ajax&cmd=202&uid=${this.uid}&corp_url=${this.corp_url}`,
            noLoading: true
          })
          .then(res => {
            if (res.data.data.token) {
              if (res.data.data.status == "CONFIRM") {
                this.$common.pcToastSuccess("已确认登录");
                window.clearInterval(this.loginInterval);
                window.location.href = "/index.php";
              }

              // this.intoSysTem(res.data.data.token, {})
            } else {
              if (res.data.data.status == "SCANED") {
                this.scanedQrcode = true;
                // this.$common.pcToastSuccess("已扫描，等待确认登录");
              }
              if (res.data.data.status == "CANCEL") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("已取消登录");
                this.getQRCode();
              }
              if (res.data.data.status == "NO_PERMISSION") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("无权限");
                this.getQRCode();
              }
              if (res.data.data.status == "INVALID") {
                this.scanedQrcode = false;
                // this.$common.pcToastFail("无效二维码");
                this.getQRCode();
              }
              if (res.data.data.status == "ACCOUNT_INVALID") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("找不到对应账号");
                this.getQRCode();
              }
            }
          });
      }, 1500);
    },
    async handleOrganizationCodeChange() {
      let corp_url = this.formData.OrganizationCode.trim()
      let res = await this.$common.http({ method: 'get', url: `/index.php?model=login&m=index&a=ajax&cmd=106&corp_url=${corp_url}` }).catch(() => {
        this.loginEqCode = ""
        this.company_name = ""
        this.had_exec = 0
        this.errorMessage = "未找到对应学校，请确认组织机构代码是否正确"
      })
      if (res.data.errcode == 0) {
        this.errorMessage = ""
        this.loginEqCode = ""
        this.company_name = res.data.data.company_name
        this.had_exec = res.data.data.had_exec
        if (res.data.data.had_exec == 1) {
          this.getQRCode()
        }
      }
    },
    getQRCode() {
      let corp_url = this.formData.OrganizationCode.trim()
      if (this.loginInterval) {
        window.clearInterval(this.loginInterval);
      }
      const moblieUrl = encodeURIComponent(
        `/view_src_dist/index.html#/nhwx/checkPcEqCodeLogin?t=${new Date().getTime()}`
      );
      this.$common
        .http({
          noLoading: true,
          method: "get",
          url: `/index.php?model=login&a=ajax&cmd=201&src_url=${moblieUrl}&corp_url=${corp_url}`
          // url: `/api/authorize/get_wxwork_login_qrcode?corp_url=${this.formData.com_id}&src_url=${moblieUrl}`
        })
        .then(res => {
          this.uid = res.data.data.uid;
          this.loginEqCode = res.data.data.url;
          this.corp_url = res.data.data.corp_url;
          if (this.qrcodeObj) {
            this.qrcodeObj.clear();
          }
          // console.log(
          //   `#/rhwx/checkPcEqCodeLogin?com_id=${this.formData.com_id}&uid=${this.uid}`
          // )
          document.getElementById("qrcode").innerHTML = "";
          this.qrcodeObj = new QRCode("qrcode", {
            width: 243,
            height: 243,
            text: this.loginEqCode
          });
          this.startLoginInterval();
        });
    },
    onConfirmBinding() {
      this.$common.http({ url: "/index.php?model=privilege&m=ajax&cmd=215", data: { data: JSON.stringify({ userid: this.formData.userid }) } }).then(() => {
        // window.location.href = "/index.php";
        window.location.reload();
        this.$common.pcSuccess("绑定成功");
      })
    }
  },
  watch: {
    count() {
      setTimeout(() => {
        if (this.count > 0) {
          this.count--;
        }
      }, 1000);
    },
    privilegeConfig(n) {
      console.log("权限变化", n);
    },
    adminInfo() {
      console.log("adminInfo变化");
    }
  }
};
</script>

<style scoped lang="less">
.page-login {
  height: 100vh;

  .qrcodeDiv {
    width: 283px;
    height: 283px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #e2e2e2;
    margin: 0 auto;
    position: relative;
  }
  .scanedQrcode {
    padding-top: 10px;
    padding-left: 115px;
    height: 57px;
    position: relative;
    img {
      position: absolute;
      left: 70px;
      top: 17px;
      width: 40px;
    }
    p {
      text-align: left;
      margin: 0;
    }
    .p1 {
      font-size: 20px;
    }
  }
  .hide {
    display: none;
  }
  .captchaCode {
    width: 65%;
  }
  .captchaCodeImg {
    position: absolute;
    width: 34%;
    right: 0;
    cursor: pointer;
  }
  .login-index {
    width: 432px;
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    margin-top: 30px;
    color: #353535;
    border-radius: 5px;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
    .codeImg {
      position: absolute;
      right: 0;
      top: 0;
      width: 33px;
      cursor: pointer;
    }
    .textImg {
      position: absolute;
      right: 30px;
      top: 3px;
      width: 80px;
    }
  }
  .login-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(./assets/img/qy_login_banner.jpg) no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    .title {
      margin-left: 28px;
      font-size: 36px;
      color: #fff;
    }
    img {
      height: 78px;
      margin-right: 20px;
    }
  }
  .login-main {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 0;
    height: calc(100vh - 300px);
    background: url(./assets/img/qy_main_bg.jpg) no-repeat;
    background-size: cover;
    .login-type {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .imgs {
        display: none;
        // display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 13px;
        .img1 {
          width: 100px;
          height: 21px;
        }
        .img2 {
          height: 56px;
          width: 56px;
        }
      }
    }
    .login-title {
      width: 300px;
      margin: 0 0 20px 0;
      font-size: 24px;
      color: #000000;
      text-align: left;
    }

    .controler {
      text-align: center;
      cursor: pointer;
      .controler-check {
        overflow: hidden;
        width: 100%;
        .check-left {
          float: left;
          width: 50px;
        }
        .check-right {
          float: right;
          .green:hover {
            text-decoration: underline;
          }
          .green {
            color: #59c3aa;
          }
        }
      }
      .login-btn {
        background: #59c3aa;
        border-color: #59c3aa;
        width: 100%;
        margin-top: 3px;
        height: 38px;
        border-radius: 4px;
        font-size: 14px;
      }
      .controler-info {
        margin-top: 20px;
        font-size: 14px;
      }
    }
  }
}


</style>
<style lang="less">
.page-login {
  .el-input__inner {
    height: 42px;
  }
  .el-input__icon {
    line-height: 42px;
    height: auto;
    font-size: 18px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #59c3aa;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #59c3aa;
    background: #59c3aa;
  }
  .forgetPassword{
    display: none;
  }
}
</style>
